// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OutcomeTile_tile__LME3Y {
  padding: 0.75rem 1rem;
  gap: 0.125rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

.OutcomeTile_tile__LME3Y h3 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
}

.OutcomeTile_tile__LME3Y dd {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--text-secondary);
}

.OutcomeTile_tile__LME3Y dd.OutcomeTile_p__a-WYn {
  margin-top: 0.25rem;
  font-weight: 600;
  color: var(--primary);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 560px) {
  .OutcomeTile_tile__LME3Y {
    padding: 0.75rem;
    gap: 0.25rem;
    overflow-wrap: normal;
  }

  .OutcomeTile_tile__LME3Y h3 {
    font-size: 0.9375rem;
    line-height: 1.3;
  }

  .OutcomeTile_tile__LME3Y dd {
    font-size: 0.8125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Research/OutcomeTile.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".tile {\n  padding: 0.75rem 1rem;\n  gap: 0.125rem;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.tile h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.tile dd {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n}\n\n.tile dd.p {\n  margin-top: 0.25rem;\n  font-weight: 600;\n  color: var(--primary);\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 560px) {\n  .tile {\n    padding: 0.75rem;\n    gap: 0.25rem;\n    overflow-wrap: normal;\n  }\n\n  .tile h3 {\n    font-size: 0.9375rem;\n    line-height: 1.3;\n  }\n\n  .tile dd {\n    font-size: 0.8125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `OutcomeTile_tile__LME3Y`,
	"p": `OutcomeTile_p__a-WYn`
};
export default ___CSS_LOADER_EXPORT___;
